import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormRhombus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconFormRhombus"><Path d="M11.9995 1C12.2516 1.00015 12.4869 1.12733 12.6255 1.33789L19.3755 11.5879C19.5401 11.838 19.5401 12.162 19.3755 12.4121L12.6255 22.6621C12.4869 22.8727 12.2516 22.9998 11.9995 23C11.7474 23 11.5123 22.8727 11.3736 22.6621L4.62357 12.4121C4.45881 12.1619 4.45881 11.8381 4.62357 11.5879L11.3736 1.33789L11.4292 1.2627C11.5707 1.09725 11.7788 1 11.9995 1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormRhombus;
